import TermExamsView from '../components/TermExamsView';

const AdminTermExams = () => <TermExamsView role="admin" />;

export default AdminTermExams;
